import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { FDBox, FDStack } from '@facet-wealth/design';
import { PathSelectors } from 'Views/Page/Content/Templates/roadmapExplorerPageTemplate/pathSelectors';
import UpdatedScenarioChartWithEmphasizedItems from 'Organisms/UpdatedScenarioChartWithEmphasizedItems';
import PlannerInsightChatMetaOverrideSet from '../PlannerInsightChat/metaOverrideSet';
import { PlannerInsightChatLayout } from '../PlannerInsightChat/layout';
import { RoadmapDeliverableWrapperLayout } from '../Wrapper/RoadmapDeliverableWrapperLayout';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const paths = resource.attr('paths')?.resources()?.list() ?? [];
  const chartResource = resource.attr('chart')?.resources()?.head();
  const [selectedPath, setSelectedPath] = useState(paths[0]?.id());
  const PlannerInsightChat = (
    <MetaResourceRenderer
      resource={resource} // has attrs for cfp insight
      layout={PlannerInsightChatLayout}
      metaOverrideSet={PlannerInsightChatMetaOverrideSet}
    />
  );

  return (
    <RoadmapDeliverableWrapperLayout pushNavToBottom={false} forceFullHeight>
      <FDStack
        direction={'column'}
        alignItems={'center'}
        spacing={5}
        padding={2}
        width={'100%'}
        flexGrow={1}
      >
        <FDBox maxWidth={600}>
          {PlannerInsightChat}
        </FDBox>
        {chartResource && paths.length > 0 ? (
          <>
            <FDStack direction={'column'} spacing={2} justifyContent={'center'} alignItems={'center'}>
              <PathSelectors
                selectedPath={selectedPath}
                setSelectedPath={setSelectedPath}
                paths={resource.attr('paths').resources().list()}
              />
            </FDStack>
            <FDStack maxHeight={'90vh'} minHeight={'300px'} flexGrow={1} width={'100%'}>
              <UpdatedScenarioChartWithEmphasizedItems
                selectedDataSetId={selectedPath}
                chartDataSourceIdsToShow={paths.map(path => path.id())}
                chartDataResource={chartResource}
                showLegend={false}
              />
            </FDStack>
          </>
        ) : null}
      </FDStack>
    </RoadmapDeliverableWrapperLayout>
  );
};

export default Layout;
